/**
 * Created by viruser on 2018/8/23.
 */
const transferData = {
  data: {},
  saveData (data) {
    this.data = data
  },
  getData () {
    return JSON.parse(JSON.stringify(this.data))
  },
  removeData () {
    this.data = {}
  }
}
export  default transferData



// WEBPACK FOOTER //
// ./src/assets/js/state.js